export enum VorRecordStatus {
    Active,
    Completed,
    Pending
}

export interface IVorRecord {
    Id?: number;

    VehicleId: number;

    StartDate: Date;

    EndDate?: Date;

    Description: string;

    InPast?: boolean;

    vorStatus?: string;
    status?: VorRecordStatus;
}
